import { defineStore } from 'pinia';
import type { Ref } from 'vue';
import { computed, ref } from 'vue';

import { msalConfig } from '@/service/auth/config';
import type { AccountInfo, IPublicClientApplication, InteractionStatus } from '@azure/msal-browser';
import { PublicClientApplication } from '@azure/msal-browser';

export default defineStore('auth', () => {
  const msalInstance: Ref<IPublicClientApplication | null> = ref(null);
  const accounts: Ref<AccountInfo[] | null> = ref(null);
  const inProgress: Ref<InteractionStatus | null> = ref(null);

  const isAuthenticated = computed(() => {
    return !!accounts.value && accounts.value.length > 0;
  });

  const setMsalInstance = (newMsalInstance: IPublicClientApplication) => {
    msalInstance.value = newMsalInstance;
  };

  const setAccounts = (newAccounts: AccountInfo[]) => {
    accounts.value = newAccounts;
  };

  const setInProgress = (newInProgress: InteractionStatus) => {
    inProgress.value = newInProgress;
  };

  const initMsalInstance = async () => {
    const msalInstance = await PublicClientApplication.createPublicClientApplication(msalConfig);
    setMsalInstance(msalInstance);
    return msalInstance;
  };

  return {
    msalInstance,
    accounts,
    inProgress,
    isAuthenticated,
    initMsalInstance,
    setMsalInstance,
    setAccounts,
    setInProgress,
  };
});
